import React from 'react'

export function HighlightedElement({ children }) {
  return <span className="font-weight-medium">{children}</span>
}

export function Section({ children }) {
  return (
    <h3 className="font-size-large margin-bottom-normal shade-10">
      {children}
    </h3>
  )
}
